export enum invoiceStatus {
  draft,
  paid,
  overdue,
  outstanding,
}
